export enum AlertTypeContract {
  MilestoneTaskEstimate = 0,
  TimeEntryTime = 1,
  PercentageComplete = 2,
  Unknown = 3,
}
